/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AppRoutes, RouteParams } from "src/app/constants";
import { AdminModulesPage } from "./admin-modules.page";

const routes: Routes = [
  {
    path: "",
    component: AdminModulesPage,
  },
  {
    path: AppRoutes.add,
    loadChildren: () => import("./module-form/module-form.module").then(m => m.ModuleFormPageModule),
  },
  {
    path: `:${RouteParams.moduleId}`,
    loadChildren: () => import("./module-detail/module-detail.module").then(m => m.ModuleDetailPageModule),
  },
  {
    path: `:${RouteParams.moduleId}/${AppRoutes.edit}`,
    loadChildren: () => import("./module-form/module-form.module").then(m => m.ModuleFormPageModule),
  },
  {
    path: `:${RouteParams.moduleId}/${AppRoutes.chapters}/${AppRoutes.add}`,
    loadChildren: () => import("./chapter-form/chapter-form.module").then(m => m.ChapterFormPageModule),
  },
  {
    path: `:${RouteParams.moduleId}/${AppRoutes.chapters}/:${RouteParams.chapterId}`,
    loadChildren: () => import("./chapter-detail/chapter-detail.module").then(m => m.ChapterDetailPageModule),
  },
  {
    path: `:${RouteParams.moduleId}/${AppRoutes.chapters}/:${RouteParams.chapterId}/${AppRoutes.edit}`,
    loadChildren: () => import("./chapter-form/chapter-form.module").then(m => m.ChapterFormPageModule),
  },
  {
    path: `:${RouteParams.moduleId}/${AppRoutes.chapters}/:${RouteParams.chapterId}/${AppRoutes.challenges}/${AppRoutes.add}`,
    loadChildren: () => import("./challenge-form/challenge-form.module").then(m => m.ChallengeFormPageModule),
  },
  {
    path: `:${RouteParams.moduleId}/${AppRoutes.chapters}/:${RouteParams.chapterId}/${AppRoutes.challenges}/:${RouteParams.challengeId}`,
    loadChildren: () => import("./challenge-detail/challenge-detail.module").then(m => m.ChallengeDetailPageModule),
  },
  {
    path: `:${RouteParams.moduleId}/${AppRoutes.chapters}/:${RouteParams.chapterId}/${AppRoutes.challenges}/:${RouteParams.challengeId}/${AppRoutes.edit}`,
    loadChildren: () => import("./challenge-form/challenge-form.module").then(m => m.ChallengeFormPageModule),
  },
  {
    path: `:${RouteParams.moduleId}/${AppRoutes.chapters}/:${RouteParams.chapterId}/${AppRoutes.challenges}/:${RouteParams.challengeId}/${AppRoutes.steps}/${AppRoutes.add}`,
    loadChildren: () => import("./step-form/step-form.module").then(m => m.StepFormPageModule),
  },
  {
    path: `:${RouteParams.moduleId}/${AppRoutes.chapters}/:${RouteParams.chapterId}/${AppRoutes.challenges}/:${RouteParams.challengeId}/${AppRoutes.steps}/:${RouteParams.stepId}`,
    loadChildren: () => import("./step-detail/step-detail.module").then(m => m.StepDetailPageModule),
  },
  {
    path: `:${RouteParams.moduleId}/${AppRoutes.chapters}/:${RouteParams.chapterId}/${AppRoutes.challenges}/:${RouteParams.challengeId}/${AppRoutes.steps}/:${RouteParams.stepId}/${AppRoutes.edit}`,
    loadChildren: () => import("./step-form/step-form.module").then(m => m.StepFormPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminModulesPageRoutingModule {}
